import { create } from 'zustand';

interface UIState {
  isLoading: boolean;
  toast: { message: string; type: 'success' | 'error' | 'info' } | null;
  modal: { type: string; data?: any } | null;
  setLoading: (isLoading: boolean) => void;
  showToast: (message: string, type?: 'success' | 'error' | 'info') => void;
  hideToast: () => void;
  openModal: (type: string, data?: any) => void;
  closeModal: () => void;
}

export const useUIStore = create<UIState>((set) => ({
  isLoading: false,
  toast: null,
  modal: null,

  setLoading: (isLoading) => set({ isLoading }),

  showToast: (message, type = 'info') => {
    set({ toast: { message, type } });
    // Auto hide after 3 seconds
    setTimeout(() => set({ toast: null }), 3000);
  },

  hideToast: () => set({ toast: null }),

  openModal: (type, data) => set({ modal: { type, data } }),

  closeModal: () => set({ modal: null })
}));
